<div class="component-wrapper">
  <div (insClickOutside)="clickOutside()">
    <div #colorButton class="colorViewer" (click)="toggleSelector(colorButton)">
      <ng-content></ng-content>
      @if (showDefaultSelector) {
        <div class="colorPickerContent">
          <div class="colorPickerElement" [ngStyle]="{'background-color': '#' + value}"></div>
          <mat-icon svgIcon={{getIconName()}} class="expandIcon"></mat-icon>
        </div>
      }
    </div>

    @if (showSelector) {
      <div class="colorSelector" [class.withoutEmptyButton]="!enableEmptyColor" [ngStyle]="selectorPosition" >
        <div class="popupMenuHeader">
          <div class="popupMenuTitle">Color Palette</div>
          <mat-icon class="dialogCloseIcon" svgIcon="dialog.close" (click)="closePopup()"></mat-icon>
        </div>
        <div class="colorPalette">
          @for (color of colorList; track color; let index = $index) {
            <div (click)="onColorPicked(color.color)" class="colorOption {{color.color}}" [ngStyle]="specifyColor(index)"></div>
          }
        </div>
        @if (enableEmptyColor) {
          <div class="emptyButtonContainer">
            <div class="textButton" (click)="emptyColor()">No Color</div>
          </div>
        }
      </div>
    }
  </div>
</div>

